import { ChangeDetectorRef, Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ARService } from '../../ar.service';
import {
  dataARPaymentPlan,
  dataARLedger,
  dataARPaymentPlanLedgerItem,
  dataARPaymentPlanItem,
  enumValidValueItem
} from '../../_models/ar.models';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';

@Component({
  standalone: false,
  selector: 'app-plan-create',
  templateUrl: './plan-create.component.html',
  styleUrls: ['./plan-create.component.css']
})
export class PlanCreateComponent implements OnInit {

  ledgerItemColumns: string[] = ['procedure', 'code', 'amount'];
  planItemColumns: string[] = ['number', 'due', 'amount', 'status'];

  mode: string = 'create';
  paymentPlanId: string;
  mergePaymentPlanId: string;

  isLoading: boolean = false;
  PatientId: string;
  paymentPlan: dataARPaymentPlan;
  ledgerItems: dataARLedger[] = [];
  deletedPlanItems: dataARPaymentPlanItem[] = [];
  deletedPlans: dataARPaymentPlan[] = [];
  paymentPlansToMerge: dataARPaymentPlan[] = [];

  numberOfPayments: number = 6;
  defaultNumberOfPayments: number = 6;
  downPaymentAmount: number = 0;
  firstPaymentDate: Date = new Date();
  minDate: Date = new Date();

  enumPaymentPlanStatusPaidItem: string = '00000095-1000-0000-0000-000000000004';
  //enumPaymentPlanStatusPaid: string = '00000083-1000-0000-0000-000000000002';

  planItemStatusEnums: enumValidValueItem[] = [];

  constructor(
    public dialogRef: MatDialogRef<PlanCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private changeRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.ledgerItems = this.data.ledgerItems;

    console.log('this.ledgerItems', this.ledgerItems);

    this.mergePaymentPlanId = this.data.mergePaymentPlanId;
    this.PatientId = this.data.PatientId;
    this.mode = this.data.mode;
    this.paymentPlansToMerge = this.data.paymentPlansToMerge;
    this.init();
  }

  async init() {

    this.isLoading = true;
    let promises: any[] = [
      this.getPlanStatusEnums(),
    ];

    if (this.mode === 'create') {

      this.paymentPlan = new dataARPaymentPlan();
      this.paymentPlan.PatientId = this.PatientId;
      this.paymentPlan.enumPaymentTypeID = '';
      this.paymentPlan.enumPaymentPlanStatusID = '';
      this.paymentPlan.isPatientAccepted = false;
      this.paymentPlan.AcceptedDate = null;
      this.paymentPlan.xauditDeleted = false;
      this.paymentPlan.dataARPaymentPlanItems = [];
      this.paymentPlan.dataARPaymentPlanLedgerItems = [];

      this.paymentPlan.dataARPaymentPlanLedgerItems = this.ledgerItems.map(ledgerItem => {
        let planLedgerItem: dataARPaymentPlanLedgerItem = new dataARPaymentPlanLedgerItem();
        planLedgerItem.LedgerID = ledgerItem.LedgerID;
        planLedgerItem.xauditDeleted = false;
        planLedgerItem.dataARLedger = ledgerItem;
        return planLedgerItem;
      });

      this.paymentPlan.TotalAmount = this.returnPlanAmount(this.ledgerItems);

      let now = new Date();
      this.firstPaymentDate = now;

      //this.paymentPlan.Description = `Payment Plan ${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
      this.initPlanItems(this.paymentPlan, this.numberOfPayments);
    } else if (this.mode === 'edit') {
      console.log('EDITING!');
      this.paymentPlanId = this.data.paymentPlanId;
      promises.push(this.getPaymentPlan(this.paymentPlanId));
    } else {

      this.paymentPlansToMerge.forEach(plan => {
        plan.xauditDeleted = true;
      });

      this.deletedPlans = this.paymentPlansToMerge;

      // create a new plan
      this.paymentPlan = new dataARPaymentPlan();
      this.paymentPlan.PatientId = this.PatientId;
      this.paymentPlan.enumPaymentTypeID = '';
      this.paymentPlan.enumPaymentPlanStatusID = '';
      this.paymentPlan.isPatientAccepted = false;
      this.paymentPlan.AcceptedDate = null;
      this.paymentPlan.xauditDeleted = false;
      this.paymentPlan.dataARPaymentPlanItems = [];
      this.paymentPlan.dataARPaymentPlanLedgerItems = [];

      this.paymentPlan.dataARPaymentPlanLedgerItems = this.ledgerItems.map(ledgerItem => {
        let planLedgerItem: dataARPaymentPlanLedgerItem = new dataARPaymentPlanLedgerItem();
        planLedgerItem.LedgerID = ledgerItem.LedgerID;
        planLedgerItem.xauditDeleted = false;
        planLedgerItem.dataARLedger = ledgerItem;
        return planLedgerItem;
      });

      let planItems: dataARPaymentPlanItem[] = [];

      this.paymentPlansToMerge.forEach(plan => {
        let paidPlanItems = plan.dataARPaymentPlanItems.filter(item => {
          return item.enumPaymentPlanItemStatusID === this.enumPaymentPlanStatusPaidItem;
        });
        planItems = planItems.concat(paidPlanItems);
      });

      planItems.forEach(item => {
        item.PaymentPlanID = null;
        item.PaymentPlanItemID = null;
      });

      this.paymentPlan.TotalAmount = this.returnPlanAmount(this.ledgerItems);
      this.initPlanItems(this.paymentPlan, this.numberOfPayments);
    }

    try {

      let promiseResults: any[] = await Promise.all(promises);
      this.planItemStatusEnums = promiseResults[0];

      if (promiseResults.length === 2) {
        this.paymentPlan = promiseResults[1];
        this.paymentPlan.dataARPaymentPlanItems = this.paymentPlan.dataARPaymentPlanItems.sort((a, b) => {
          let d1 = new Date(a.DueDate);
          let d2 = new Date(b.DueDate);
          return d1.getTime() - d2.getTime();
        });
        this.ledgerItems = this.paymentPlan.dataARPaymentPlanLedgerItems.map(item => {
          return item.dataARLedger;
        });
      }

      this.paymentPlan.DATA_PLAN_AMOUNT = this.calcTotalForPlanItems(this.paymentPlan);

      if (!this.paymentPlan.Description) {
        let startDate: Date;
        let endDate: Date;

        this.paymentPlan.dataARPaymentPlanItems.forEach(planItem => {
          let planItemDueDate = new Date(planItem.DueDate);

          if (!startDate) { startDate = planItemDueDate; }
          if (!endDate) { endDate = planItemDueDate; }

          if (planItemDueDate < startDate) {
            startDate = planItemDueDate
          }

          if (planItemDueDate > endDate) {
            endDate = planItemDueDate
          }
        });

        let planDescription = `Plan: ${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()} - ${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()} Total: $${this.paymentPlan.DATA_PLAN_AMOUNT}`;
        this.paymentPlan.Description = planDescription;
      }

      this.numberOfPayments = this.paymentPlan.dataARPaymentPlanItems.length;
      this.defaultNumberOfPayments = this.paymentPlan.dataARPaymentPlanItems.length;

    } catch (err) {
      console.log('err', err);
      this.createMessage("Something went wrong", "Error");  
    }

    this.isLoading = false;
    this.changeRef.detectChanges();
  }

  getStatusOfPlanItem(planItem: dataARPaymentPlanItem) {
    let status = this.planItemStatusEnums.find(statusEnum => {
      return statusEnum.ValidValueItemId === planItem.enumPaymentPlanItemStatusID;
    });

    if (status) {
      return status.ItemDisplayValue;
    } else {
      return '-';
    }
  }

  getPlanStatusEnums() {
    return this.arService.getPlanItemStatusEnums().toPromise();
  }

  calcTotalForPlanItems(paymentPlan: dataARPaymentPlan) {
    let amount = 0;
    paymentPlan.dataARPaymentPlanItems.forEach(item => {
      amount += item.Amount;
    });
    return amount;
  }

  getDateOfPayment(lastDueDate: Date, monthInc: number = 1) {

    let startMonth = lastDueDate.getMonth() + 1;
    let endMonth = startMonth + monthInc;
    let year = lastDueDate.getFullYear();

    if (endMonth > 12) {
      endMonth = (endMonth - 12);
      year++;
    }

    return [endMonth, year];
  }

  onSinglePaymentDateChanged(paymentPlan: dataARPaymentPlan) {

    paymentPlan.dataARPaymentPlanItems = paymentPlan.dataARPaymentPlanItems.sort((a, b) => {
      return a.DueDate.getTime() - b.DueDate.getTime();
    });
    
    this.firstPaymentDate = paymentPlan.dataARPaymentPlanItems[0].DueDate;

  }

  initPlanItems(paymentPlan: dataARPaymentPlan, paymentCount: number = 6) {

    let enumPaymentPlanStatusScheduled = '00000095-1000-0000-0000-000000000001';
    let enumPaymentPlanStatusPaidItem = '00000095-1000-0000-0000-000000000004';

    let alreadyPaidItems = paymentPlan.dataARPaymentPlanItems.filter(item => {
      return item.enumPaymentPlanItemStatusID !== enumPaymentPlanStatusScheduled;
    });

    let alreadyPaidAmount = 0;
    alreadyPaidItems.forEach(item => {
      alreadyPaidAmount += item.Amount;
    });

    let minPayments = alreadyPaidItems.length + 1;;

    if (minPayments > paymentCount) {
      paymentCount = minPayments;
    }

    let itemsToDelete = paymentPlan.dataARPaymentPlanItems.filter(item => {
      return item.PaymentPlanItemID !== null && item.enumPaymentPlanItemStatusID == enumPaymentPlanStatusScheduled;
    });

    this.deletedPlanItems = this.deletedPlanItems.concat(itemsToDelete);

    paymentPlan.dataARPaymentPlanItems = paymentPlan.dataARPaymentPlanItems.filter(item => {
      return !(item.PaymentPlanItemID !== null && item.enumPaymentPlanItemStatusID == enumPaymentPlanStatusScheduled);
    });

    let amount = paymentPlan.TotalAmount - alreadyPaidAmount;

    let paymentsLeftCount = paymentCount - alreadyPaidItems.length;

    let monthlyAmount = Math.round((amount / (paymentsLeftCount)) * 100) / 100;
    let itemArr: dataARPaymentPlanItem[] = paymentPlan.dataARPaymentPlanItems;

    for (let i = minPayments-1; i < paymentCount; i++) {

      let planItemPaymentDate: Date;

      if (i === 0) {
        planItemPaymentDate = this.firstPaymentDate;
      } else {
        let lastDueDate = new Date(itemArr[i - 1].DueDate);
        let dateMonthYearPair = this.getDateOfPayment(lastDueDate, 1);
        let planItemPaymentDateString = `${dateMonthYearPair[0]}/1/${dateMonthYearPair[1]}`
        planItemPaymentDate = new Date(planItemPaymentDateString);
      }

      let planItem: dataARPaymentPlanItem = new dataARPaymentPlanItem();      
      planItem.Description = '';
      planItem.DueDate = planItemPaymentDate;
      planItem.Amount = monthlyAmount;
      planItem.xauditDeleted = false;
      planItem.enumPaymentPlanItemStatusID = enumPaymentPlanStatusScheduled;
      itemArr.push(planItem);
    }

    paymentPlan.dataARPaymentPlanItems = itemArr;

    let total = this.calcTotalForPlanItems(paymentPlan);
    if ((amount + alreadyPaidAmount) > total) {
      let missingAmount = (amount + alreadyPaidAmount) - total;
      missingAmount = Math.round(missingAmount * 100) / 100;
      let finalAmount = paymentPlan.dataARPaymentPlanItems[paymentPlan.dataARPaymentPlanItems.length - 1].Amount + missingAmount;
      finalAmount = Math.round(finalAmount * 100) / 100;
      paymentPlan.dataARPaymentPlanItems[paymentPlan.dataARPaymentPlanItems.length - 1].Amount = finalAmount;
    } else if ((amount + alreadyPaidAmount) < total) {
      let missingAmount = total - (amount + alreadyPaidAmount);
      missingAmount = Math.round(missingAmount * 100) / 100;
      let finalAmount = paymentPlan.dataARPaymentPlanItems[paymentPlan.dataARPaymentPlanItems.length - 1].Amount - missingAmount;
      finalAmount = Math.round(finalAmount * 100) / 100;
      paymentPlan.dataARPaymentPlanItems[paymentPlan.dataARPaymentPlanItems.length - 1].Amount = finalAmount;
    }
  }  

  createPaymentPlan(paymentPlan: dataARPaymentPlan) {
    let planClone: dataARPaymentPlan = JSON.parse(JSON.stringify(paymentPlan));
    planClone.dataARPaymentPlanLedgerItems.forEach(planLedgerItem => {
      planLedgerItem.dataARLedger = null;
    });

    return this.arService.savePaymentPlan(planClone).toPromise();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: "top"
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  calcAdjustedPrice(ledgerItem: dataARLedger) {
    let enumCoverageTypePCT: string = '00000048-1000-0000-0000-000000000001';
    let enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';

    if (!ledgerItem.dataARTransactionItem) {
      return ledgerItem.Amount;
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypePCT) {
      if (ledgerItem.dataARTransactionItem.DiscountPCT == null || typeof ledgerItem.dataARTransactionItem.DiscountPCT == "undefined") {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount * ((ledgerItem.dataARTransactionItem.DiscountPCT) / 100);
      }
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypeAmount) {
      if (ledgerItem.dataARTransactionItem.DiscountAmount == null || typeof ledgerItem.dataARTransactionItem.DiscountAmount == "undefined") {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount - ledgerItem.dataARTransactionItem.DiscountAmount;
      }
    }

    return ledgerItem.Amount;
  }

  returnPlanAmount(ledgerItems: dataARLedger[]) {
    let amount = 0;
    ledgerItems.forEach(item => {
      let cost = this.calcAdjustedPrice(item);
      amount += cost;
    });

    return amount;
  }

  getPaymentPlan(PaymentPlanID: string) {
    return this.arService.getPaymentPlan(PaymentPlanID).toPromise();
  }

  clearPaymentPlan() {
    this.downPaymentAmount = 0;
    this.numberOfPayments = this.defaultNumberOfPayments;
    this.initPlanItems(this.paymentPlan, this.numberOfPayments);
  }

  checkForInvalidInput(inputToCheck: string) {    
    if (inputToCheck === 'downPayment') {
      if (this.downPaymentAmount > this.paymentPlan.TotalAmount) {
        this.downPaymentAmount = this.paymentPlan.TotalAmount;
      }
      if (this.downPaymentAmount < 0) {
        this.downPaymentAmount = 0;
      }
      this.initPlanItems(this.paymentPlan, this.numberOfPayments);
    }
  }

  removePaymentPlans() {
    let promises = this.deletedPlans.map(plan => {
      plan.dataARPaymentPlanItems = [];
      plan.dataARPaymentPlanLedgerItems = [];
      plan.xauditDeleted = true;
      return this.arService.savePaymentPlan(plan).toPromise();
    });
    return Promise.all(promises);
  }

  removePaymentPlanItems() {
    this.deletedPlanItems.forEach(item => {
      item.xauditDeleted = true;
    });
    this.deletedPlanItems = this.deletedPlanItems.filter(item => {
      return item.PaymentPlanItemID != null;
    });
    let promises = this.deletedPlanItems.map(item => {
      return this.arService.savePaymentPlanItem(item).toPromise();
    });
    return Promise.all(promises);
  }

  async savePaymentPlan() {
    this.isLoading = true;

    if (this.paymentPlan.enumPaymentPlanStatusID === LEDGER_ITEM_STATUS.Paid) {
      this.close(false);
      return;
    }

    if (this.mode === 'create') {
      try {
        await this.createPaymentPlan(this.paymentPlan);
      } catch (err) {
        console.log('err', err);
        this.createMessage("Something went wrong", "Error");  
      }
    } else {

      let promises: any[] = [
        this.removePaymentPlans(),
        this.removePaymentPlanItems(),
      ];

      try {
        await Promise.all(promises);
        await this.createPaymentPlan(this.paymentPlan);
      } catch (err) {
        console.log('err', err);
        this.createMessage("Something went wrong", "Error");  
      }

    }
    this.isLoading = false;
    this.close(this.paymentPlan);
  }

  checkIfValid() {
    let itemAmountTotal = 0;
    this.ledgerItems.forEach(item => {
      itemAmountTotal += this.calcAdjustedPrice(item);
    });

    let flag1 = (this.calcTotalForPlanItems(this.paymentPlan) + this.downPaymentAmount) === itemAmountTotal;
    return flag1;
  }

}
